export default {
    purchases: [],
    pagination: null
};
